var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.disabled)?_c('a',{attrs:{"target":"_blank","href":_vm._f("jwtToken")(_vm.url)}},[_vm._v(_vm._s(_vm._linkText))]):_c('b-input',{attrs:{"disabled":_vm.disabled,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', {
      valuePath: _vm.valuePath,
      value: $event,
    })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }